module.exports = __webpack_public_path__ + "static/media/Salary50k.2be4742c.png";